export default () => ({
  started: false,
  cloudsPopped: 0,
  exited: false
})
